// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"572":"11ca0e73","990":"e8931867"}[chunkId] + ".chunk.css";
};